"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _reactTextMask = _interopRequireDefault(require("react-text-mask"));
var _styles2 = _interopRequireDefault(require("./styles"));
var _excluded = ["inputRef", "mask"],
  _excluded2 = ["mask", "inputMode"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
var masks = {
  cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  cnpj: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  cep: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  duracaoHoraMinuto: [/\d/, /\d/, ':', /\d/, /\d/],
  cns: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  faturaPassagem: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  requisicaoPassagem: [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  sequencialApac: [/\d/, /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  numeroAutos: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
  numeroOab: [/[A-Za-z]/, /[A-Za-z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[Ee]/],
  numeroSGPE: [/[A-Z]/, /[A-Z]/, /[A-Z]/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  hbA1c: [/\d/, /\d/, '.', /\d/, /\d/],
  glicemia: [/\d/, /\d/, /\d/, '.', /\d/, /\d/],
  telefoneFixo: ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  telefoneCelular: ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  relacaoEscavacaoDisco: [/\d/, '.', /\d/, /\d/],
  telefone: function telefone(input) {
    var numbers = input.match(/\d/g);
    var numberLength = 0;
    if (numbers) {
      numberLength = numbers.join("").length;
    }
    if (numberLength > 10) {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  },
  decs: function decs(input) {
    var mascara = [/[A-Za-z]/, /[A-Za-z\d]/, /\d/];
    var complemento = ['.', /\d/, /\d/, /\d/];
    var limite = 3;
    for (var i = 1; i < 20; i++) {
      if (input.length > limite) {
        mascara = [].concat(_toConsumableArray(mascara), complemento);
        limite = limite + 4;
      }
    }
    return mascara;
  }
};
function Masked(props) {
  var inputRef = props.inputRef,
    mask = props.mask,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], _extends({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: masks[mask] || mask,
    guide: false,
    showMask: true
  }));
}
Masked.propTypes = {
  mask: _propTypes["default"].string.isRequired,
  inputRef: _propTypes["default"].func.isRequired
};
function SttMaskedInput(props) {
  var classes = useStyles();
  var mask = props.mask,
    inputMode = props.inputMode,
    other = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    variant: "outlined",
    margin: "dense",
    fullWidth: true,
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused,
        error: classes.error
      }
    },
    InputProps: {
      inputComponent: Masked,
      inputProps: {
        mask: mask,
        inputMode: inputMode || 'text'
      },
      classes: {
        root: classes.input,
        focused: classes.cssfocused,
        notchedOutline: classes.notchedOutline,
        disabled: classes.disabled,
        error: classes.error
      }
    }
  }, other));
}
var _default = SttMaskedInput;
exports["default"] = _default;